import React, { Component } from 'react';
import { Route, Switch} from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Warehouse } from './components/Warehouse';
import { MyWarehouseRoute, MyAuthRoute, GlobalContextProvider, MyGlobal, ErrorBoundary } from './components/GlobalContext';
import { LoadPallet } from './components/LoadPallet';
import { LoadTruck } from './components/LoadTruck';
import { Inwards } from './components/Inwards';
import { MainMenu } from './components/MainMenu';
import { ToteApproval } from './components/ToteApproval';
import { TotePutAway } from './components/TotePutAway';
import { ToteMoveQC } from './components/ToteMoveQC';
import { UnloadTruck } from './components/UnloadTruck';
import { MenuComponent } from './components/MenuComponent';
import { Transfer } from './components/Transfers/Transfer';
import { LocationToLocation } from './components/Transfers/LocationToLocation';
import { AdhocTransfer } from './components/Transfers/AdhocTransfer';
import { AdhocTransferBasic } from './components/Transfers/AdhocTransferBasic';
import { Enquiry } from './components/Enquiries/Enquiry';
import { ProductEnquiry } from './components/Enquiries/ProductEnquiry';
import { LocationEnquiry } from './components/Enquiries/LocationEnquiry';
import { PrintSettings } from './components/PrintSettings/PrintSettings';
import { Freight } from './components/Freight/Freight';
import { Manifesting } from './components/Freight/Manifesting';
import { CreateManifest } from './components/Freight/CreateManifest';
import { LoadCarriers } from './components/Freight/LoadCarriers';
import { ManifestHistory } from './components/Freight/ManifestHistory';
import { ViewManifest } from './components/Freight/ViewManifest';
import { ManifestReportViewer } from './components/Freight/ManifestReportViewer';
import { CaptureSignature } from './components/Freight/CaptureSignature';
import { ManifestsInProgress } from './components/Freight/ManifestsInProgress';
import { ResumeManifest } from './components/Freight/ResumeManifest';
import { ChoosePick } from './components/PaperlessPicking/ChoosePick';
import { ActivePicks } from './components/PaperlessPicking/ActivePicks';
import { MHEWithPickRows } from './components/PaperlessPicking/MHEWithPickRows';
import { PickLocation } from './components/PaperlessPicking/PickLocation';
import { PickItem } from './components/PaperlessPicking/PickItem';
import { PickItemShorts } from './components/PaperlessPicking/PickItemShorts';
import { ShortedProducts } from './components/PaperlessPicking/ShortedProducts';
import { SelectStocktake } from './components/Stocktake/SelectStocktake';
import { MXDockChooseShipment } from './components/MXDock/MXDockChooseShipment';
import { SupervisorSignoff } from './components/MXDock/SupervisorSignoff';
import { UnknownCarton } from './components/MXDock/UnknownCarton';
import { AssignLocations } from './components/MXDock/AssignLocations';
import { ScanCarton } from './components/MXDock/ScanCarton';
import { StocktakeTasks } from './components/Stocktake/StocktakeTasks';
import { FirstCount_Location } from './components/Stocktake/FirstCount/FirstCount_Location';
import { FirstCount_ConfirmLocation } from './components/Stocktake/FirstCount/FirstCount_ConfirmLocation';
import { FirstCount_ConfirmQty } from './components/Stocktake/FirstCount/FirstCount_ConfirmQty';
import { Recount_Location } from './components/Stocktake/Recount/Recount_Location';
import { Recount_ConfirmLocation } from './components/Stocktake/Recount/Recount_ConfirmLocation';
import { Recount_ConfirmQty } from './components/Stocktake/Recount/Recount_ConfirmQty';
import { AdhocCount_Location } from './components/Stocktake/AdhocCount/AdhocCount_Location';
import { AdhocCount_ProductSelect } from './components/Stocktake/AdhocCount/AdhocCount_ProductSelect';
import { AdhocCount_ConfirmQty } from './components/Stocktake/AdhocCount/AdhocCount_ConfirmQty';
import { AddNew_ProductLocation } from './components/Stocktake/AddNew/AddNew_ProductLocation';
import { AddNew_ProductSearch } from './components/Stocktake/AddNew/AddNew_ProductSearch';
import { AddNew_ProductCount } from './components/Stocktake/AddNew/AddNew_ProductCount';
import { AddNew_ProductDetails } from './components/Stocktake/AddNew/AddNew_ProductDetails';
import { AddNew_DisplayColosysProductLocation } from './components/Stocktake/AddNew/AddNew_DisplayColosysProductLocation';
import { SupervisorMenu } from './components/Supervisor/SupervisorMenu';
import { UpdateLocationCharge } from './components/Supervisor/UpdateLocationCharge';
import { CartonisedChooseShipment } from './components/CartonisedInwards/CartonisedChooseShipment'
import { CartonisedScanCarton } from './components/CartonisedInwards/CartonisedScanCarton'
import { CartonisedSupervisorSignoff } from './components/CartonisedInwards/CartonisedSupervisorSignoff';
import { CartonisedUnknownCarton } from './components/CartonisedInwards/CartonisedUnknownCarton';
import { CartonisedConfirmInwards } from './components/CartonisedInwards/CartonisedConfirmInwards';
import { LH_LoadOpenASN } from './components/LinenhouseXdoc/LH_LoadOpenASN';
import { LH_PutArray } from './components/LinenhouseXdoc/LH_PutArray';
import { LH_DecantPallet } from './components/LinenhouseXdoc/LH_DecantPallet';
import { LH_Rows } from './components/LinenhouseXdoc/LH_Rows';
import { LH_Pallet } from './components/LinenhouseXdoc/LH_Pallet';
import { LH_DecantBuildArray } from './components/LinenhouseXdoc/LH_DecantBuildArray';
import { LH_DecantAddLocation } from './components/LinenhouseXdoc/LH_DecantAddLocation';
import { RF_AdhocTransfer } from './components/Transfers/RFTransfers/RF_AdhocTransfer';
import { RF_SelectAction } from './components/Transfers/RFTransfers/RF_SelectAction';
import { RF_Pick } from './components/Transfers/RFTransfers/RF_Pick';
import { RF_Put } from './components/Transfers/RFTransfers/RF_Put';
import { RF_ConfirmPick } from './components/Transfers/RFTransfers/RF_ConfirmPick';
import { RF_ConfirmPut } from './components/Transfers/RFTransfers/RF_ConfirmPut';
import { RF_StockOnHand } from './components/Transfers/RFTransfers/RF_StockOnHand';
import { ReceivedShipments } from './components/SCSInwards/ReceivedShipments';
import { InwardsImageCapture } from './components/SCSInwards/InwardsImageCapture';
import { RF_TransferHistory } from './components/Transfers/RFTransfers/RF_TransferHistory';
import { RF_TransferDetails } from './components/Transfers/RFTransfers/RF_TransferDetails'; 

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css'
import './css/main.less'

const bootstrap = require('bootstrap')

const NotFound=()=>{
    return <div>Not Found</div>
}

export default class App extends Component {
    static displayName = App.name;
    constructor(props) {
        super(props);
      // Store the previous pathname and search strings
        this.currentPathname = null;
        this.currentSearch = null;
    }
    componentDidMount() {
        
        const { history } = this.props;

        history.listen((newLocation, action) => {
            let canGoBack = MyGlobal.backOK;
            if (!canGoBack) {

                if (action === "PUSH") {
                    if (
                        newLocation.pathname !== this.currentPathname ||
                        newLocation.search !== this.currentSearch
                    ) {
                        // Save new location
                        this.currentPathname = newLocation.pathname;
                        this.currentSearch = newLocation.search;

                        // Clone location object and push it to history
                        history.push({
                            pathname: newLocation.pathname,
                            search: newLocation.search
                        });
                    }
                } else {
                    // Send user back if they try to navigate back
                    history.go(1);

                }
            }
            MyGlobal.backOK = true;
        });
    }
    render() {
        return (
            <GlobalContextProvider>
                <Layout>
                    <Switch>
                        <Route exact path='/' component={Home} />
                        <MyAuthRoute path='/warehouse' component={Warehouse} />
                        <MyWarehouseRoute path='/mainmenu' component={MainMenu} />
                        <MyWarehouseRoute path='/inwards' component={Inwards} />
                        <MyWarehouseRoute path='/loadpallet' component={LoadPallet} />
                        <MyWarehouseRoute path='/loadtruck' component={LoadTruck} />
                        <MyWarehouseRoute path='/toteapproval' component={ToteApproval} />
                        <MyWarehouseRoute path='/toteputaway' component={TotePutAway} />
                        <MyWarehouseRoute path='/totemoveqc' component={ToteMoveQC} />
                        <MyWarehouseRoute path='/unloadtruck' component={UnloadTruck} />
                        <MyWarehouseRoute path='/menucomponent' component={MenuComponent} />
                        <MyWarehouseRoute path='/transfers/transfer' component={Transfer} />
                        <MyWarehouseRoute path='/transfers/LocationToLocation' component={LocationToLocation} />
                        <MyWarehouseRoute path='/transfers/AdhocTransfer' component={AdhocTransfer} />
                        <MyWarehouseRoute path='/transfers/AdhocTransferBasic' component={AdhocTransferBasic} />
                        <MyWarehouseRoute path='/Enquiries/Enquiry' component={Enquiry} />
                        <MyWarehouseRoute path='/Enquiries/LocationEnquiry' component={LocationEnquiry} />
                        <MyWarehouseRoute path='/Enquiries/ProductEnquiry' component={ProductEnquiry} />
                        <MyWarehouseRoute path='/printSettings/PrintSettings' component={PrintSettings} />
                        <MyWarehouseRoute path='/freight/Freight' component={Freight} />
                        <MyWarehouseRoute path='/freight/Manifesting' component={Manifesting} />
                        <MyWarehouseRoute path='/freight/CreateManifest' component={CreateManifest} />
                        <MyWarehouseRoute path='/freight/LoadCarriers' component={LoadCarriers} />
                        <MyWarehouseRoute path='/freight/ManifestHistory' component={ManifestHistory} />
                        <MyWarehouseRoute path='/freight/ViewManifest' component={ViewManifest} />
                        <MyWarehouseRoute path='/freight/ManifestReportViewer' component={ManifestReportViewer} />
                        <MyWarehouseRoute path='/freight/CaptureSignature' component={CaptureSignature} />
                        <MyWarehouseRoute path='/freight/ManifestsInProgress' component={ManifestsInProgress} />
                        <MyWarehouseRoute path='/freight/ResumeManifest' component={ResumeManifest} />
                        <MyWarehouseRoute path='/paperlesspicking/ChoosePick' component={ChoosePick} />
                        <MyWarehouseRoute path='/paperlesspicking/ActivePicks' component={ActivePicks} />
                        <MyWarehouseRoute path='/paperlesspicking/MHEWithPickRows' component={MHEWithPickRows} />
                        <MyWarehouseRoute path='/paperlesspicking/PickLocation' component={PickLocation} />
                        <MyWarehouseRoute path='/paperlesspicking/PickItemShorts' component={PickItemShorts} />
                        <MyWarehouseRoute path='/paperlesspicking/PickItem' component={PickItem} />
                        <MyWarehouseRoute path='/paperlesspicking/ShortedProducts' component={ShortedProducts} />
                        <MyWarehouseRoute path='/Stocktake/SelectStocktake' component={SelectStocktake} />
                        <MyWarehouseRoute path='/MXDock/MXDockChooseShipment' component={MXDockChooseShipment} />
                        <MyWarehouseRoute path='/MXDock/SupervisorSignoff' component={SupervisorSignoff} />
                        <MyWarehouseRoute path='/MXDock/UnknownCarton' component={UnknownCarton} />
                        <MyWarehouseRoute path='/MXDock/AssignLocations' component={AssignLocations} />
                        <MyWarehouseRoute path='/MXDock/ScanCarton' component={ScanCarton} />
                        <MyWarehouseRoute path='/Stocktake/StocktakeTasks' component={StocktakeTasks} />
                        <MyWarehouseRoute path='/Stocktake/FirstCount/FirstCount_Location' component={FirstCount_Location} />
                        <MyWarehouseRoute path='/Stocktake/FirstCount/FirstCount_ConfirmLocation' component={FirstCount_ConfirmLocation} />
                        <MyWarehouseRoute path='/Stocktake/FirstCount/FirstCount_ConfirmQty' component={FirstCount_ConfirmQty} />
                        <MyWarehouseRoute path='/Stocktake/Recount/Recount_Location' component={Recount_Location} />
                        <MyWarehouseRoute path='/Stocktake/Recount/Recount_ConfirmLocation' component={Recount_ConfirmLocation} />
                        <MyWarehouseRoute path='/Stocktake/Recount/Recount_ConfirmQty' component={Recount_ConfirmQty} />
                        <MyWarehouseRoute path='/Stocktake/AdhocCount/AdhocCount_Location' component={AdhocCount_Location} />
                        <MyWarehouseRoute path='/Stocktake/AdhocCount/AdhocCount_ProductSelect' component={AdhocCount_ProductSelect} />
                        <MyWarehouseRoute path='/Stocktake/AdhocCount/AdhocCount_ConfirmQty' component={AdhocCount_ConfirmQty} />
                        <MyWarehouseRoute path='/Stocktake/AddNew/AddNew_ProductLocation' component={AddNew_ProductLocation} />
                        <MyWarehouseRoute path='/Stocktake/AddNew/AddNew_ProductSearch' component={AddNew_ProductSearch} />
                        <MyWarehouseRoute path='/Stocktake/AddNew/AddNew_ProductCount' component={AddNew_ProductCount} />
                        <MyWarehouseRoute path='/Stocktake/AddNew/AddNew_ProductDetails' component={AddNew_ProductDetails} />
                        <MyWarehouseRoute path='/Stocktake/AddNew/AddNew_DisplayColosysProductLocation' component={AddNew_DisplayColosysProductLocation} />
                        <MyWarehouseRoute path='/Supervisor/SupervisorMenu' component={SupervisorMenu} />
                        <MyWarehouseRoute path='/Supervisor/UpdateLocationCharge' component={UpdateLocationCharge} />
                        <MyWarehouseRoute path='/CartonisedInwards/CartonisedChooseShipment' component={CartonisedChooseShipment} />
                        <MyWarehouseRoute path='/CartonisedInwards/CartonisedScanCarton' component={CartonisedScanCarton} />
                        <MyWarehouseRoute path='/CartonisedInwards/CartonisedSupervisorSignoff' component={CartonisedSupervisorSignoff} />
                        <MyWarehouseRoute path='/CartonisedInwards/CartonisedUnknownCarton' component={CartonisedUnknownCarton} />
                        <MyWarehouseRoute path='/CartonisedInwards/CartonisedConfirmInwards' component={CartonisedConfirmInwards} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_LoadOpenASN' component={LH_LoadOpenASN} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_PutArray' component={LH_PutArray} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_DecantPallet' component={LH_DecantPallet} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_Rows' component={LH_Rows} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_Pallet' component={LH_Pallet} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_DecantBuildArray' component={LH_DecantBuildArray} />
                        <MyWarehouseRoute path='/LinenhouseXdoc/LH_DecantAddLocation' component={LH_DecantAddLocation} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_AdhocTransfer' component={RF_AdhocTransfer} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_SelectAction' component={RF_SelectAction} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_Pick' component={RF_Pick} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_Put' component={RF_Put} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_ConfirmPick' component={RF_ConfirmPick} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_ConfirmPut' component={RF_ConfirmPut} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_StockOnHand' component={RF_StockOnHand} />
                        <MyWarehouseRoute path='/SCSInwards/ReceivedShipments' component={ReceivedShipments} />
                        <MyWarehouseRoute path='/SCSInwards/InwardsImageCapture' component={InwardsImageCapture} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_TransferHistory' component={RF_TransferHistory} />
                        <MyWarehouseRoute path='/Transfers/RFTransfers/RF_TransferDetails' component={RF_TransferDetails} />
                        <Route component={NotFound} />
                    </Switch>
                    </Layout>
            </GlobalContextProvider>
        );
    }
}
